import en from './en-1.json'
import de from './de-1.json'

export const defaultLocale = 'DE'

export const languages = {
    EN: en,
    DE: de,
}
